import { gql } from "@apollo/client"

export const SAVE_AGREEMENT = gql`
  mutation SaveAgreement($data: SaveAgreementInput!) {
    agreements {
      agreeToTerms(data: $data) {
        id
        userId
        agreementId
        agreedToTerms
        agreementTimestamp
        agreement {
          id
          document
          version
          createdAt
          updatedAt
        }
      }
    }
  }
`
